module.exports = __webpack_public_path__ + "media/images/application/icons/share-2f8f6ee6b0126312159293d6a13a404e.svg";